import { useState, useEffect } from "react";
import { Header, Progress, Button } from "semantic-ui-react";
import ZoneOrb from "./ZoneOrb.js";
import { VanishDiv, FrameVanishDiv, GlowButton } from "./SmallComponents";
import help from "../help.js";


function AreaGame(props) {


    const [locked, setLocked] = useState(false);
    const [lastAction, setLastAction] = useState(false);
    const [endingValue, setEndingValue] = useState(0);
    const [endLine1, setEndLine1] = useState("");
    const [endLine2, setEndLine2] = useState("");
    const [levelUpText, setLevelUpText] = useState("");


    const [feeling, setFeeling] = useState("sad");
    const [feelingColor, setFeelingColor] = useState("#003399");

    const [moodValue, setMoodValueRaw] = useState(0);
    const [moodBoost, setMoodBoost] = useState(0);
    const [maxMood, setMaxMood] = useState(100);

    const [friendEnergy, setFriendEnergyRaw] = useState(100);
    const [maxFriendEnergy, setMaxFriendEnergy] = useState(100);

    const [energy, setEnergyRaw] = useState(100);
    const [maxEnergy, setMaxEnergy] = useState(100);

    const [empathy, setEmpathy] = useState(0);
    const [empathyLevel, setEmpathyLevel] = useState(1);

    const [conversation, setConversationRaw] = useState(0);

    let feelingsToColors = {
        "sad": "#003399",
        "a little better": "#2266ff",
        "okay": "#666666",
        "happy": "#996666",
        "feeling seen": "#00A36C",
        "receptive": "#9FE2BF",
        "distant": "#7393B3",
    };

    function setConversation(newProgress) {
        if (newProgress > 100) newProgress = 100;
        if (newProgress <= 0) { newProgress = 0; }
        setConversationRaw(newProgress);

    }
    function setMoodValue(newMood) {
        if (newMood > maxMood) newMood = maxMood;
        if (newMood <= 0) { newMood = 0; }
        setMoodValueRaw(newMood);
    }
    function setEnergy(newEnergy) {
        if (newEnergy > maxEnergy) newEnergy = maxEnergy;
        if (newEnergy <= 0) { newEnergy = 0; }
        setEnergyRaw(newEnergy);
    }
    function setFriendEnergy(newEnergy) {
        if (newEnergy > maxFriendEnergy) newEnergy = maxFriendEnergy;
        if (newEnergy <= 0) { newEnergy = 0; }
        setFriendEnergyRaw(newEnergy);
    }

    //let mainWidth = document.body.clientWidth - 400;
    let mainWidth = document.body.clientWidth;

    useEffect(() => { if (props.startGame) startGame(); }, [props.startGame]);

    return <FrameVanishDiv style={{ position: "relative" }}>
        {props.renderGame && (
            <VanishDiv style={{ width: "80%", magrin: "0 10%", padding: "10px", fontSize: "20px" }}>

                {endingValue == 0 && (<Header as='h2' style={{ fontSize: "40px", color: "white", padding: "4% 10% 0 10%" }}> Your friend is {feeling}.</Header>)}
                <ZoneOrb
                    startGame={props.startGame}
                    feeling={feeling}
                    moodValue={moodValue}
                    fillColor={feelingColor}
                    size={200}
                />


                <div style={{ width: "15%", float: "left", padding: "15px 0" }}>Conversation</div>
                <Progress style={{ width: "80%", float: "left", margin: "1em" }} percent={conversation} progress inverted />
                <div style={{ clear: "both" }} />

                <div style={{ width: "15%", float: "left", padding: "15px 0" }}>Mood</div>
                <Progress style={{ width: "80%", float: "left", margin: "1em" }} percent={moodValue} indicating inverted />
                <div style={{ clear: "both" }} />

                <div style={{ width: "15%", float: "left", padding: "15px 0" }}>Friend's Energy</div>
                <Progress style={{ width: "80%", float: "left", margin: "1em" }} percent={friendEnergy} indicating inverted />
                <div style={{ clear: "both" }} />

                <br />

                <div style={{ height: "30%" }}>
                    {endingValue == 0 && (
                        <>
                            <div style={{ width: "100%", padding: "10px", display: "flex", flexDirection: "row", flexWrap: "wrap" }}>

                                <GlowButton label="Chat" locked={locked} callbackFunction={Chat} animate={"normal"} />
                                <GlowButton label="Cheer" locked={locked} callbackFunction={Cheer} animate={"normal"} />
                                {empathyLevel > 1 && (<GlowButton label="Pleasant Silence" callbackFunction={Silence}
                                    locked={locked || (feeling != "receptive" && feeling != "feeling seen")}
                                    animate={feeling == "receptive" || feeling == "feeling seen" ? "pulse" : "normal"} />)}
                                {empathyLevel > 2 && (<GlowButton label="Deep Talk" callbackFunction={DeepTalk}
                                    locked={locked || lastAction != "Cheer"}
                                    animate={lastAction == "Cheer" ? "pulse" : "normal"} />)}
                                {empathyLevel > 3 && (<GlowButton label="Soothe" callbackFunction={Soothe} locked={locked} animate={"normal"} />)}
                                {empathyLevel > 4 && (<GlowButton label="Fond Goodbye" callbackFunction={FondGoodbye} locked={locked} animate={"normal"} />)}

                            </div>
                            <div style={{ clear: "both" }} />

                            <br />
                            <br />
                            <br />
                            <div style={{ width: "15%", float: "left", padding: "15px 0", fontSize: "20px" }}>Your Energy</div>
                            <Progress style={{ width: "80%", float: "left", margin: "1em" }} percent={energy} indicating inverted />
                            <div style={{ clear: "both" }} />
                            <br />
                        </>)}

                    {endingValue > 0 && (
                        <>
                            <VanishDiv>{endLine1}</VanishDiv>
                            {endingValue > 1 && (<VanishDiv>{endLine2}</VanishDiv>)}
                            {endingValue > 2 && (<VanishDiv>Your friend is {feeling}.</VanishDiv>)}
                            {endingValue > 3 && (<><div>You gain empathy. <span style={{ color: "gold" }}>{levelUpText}</span></div>
                                <br />
                                <Button label="Talk to Another Friend" onClick={() => NewFriend()} /></>
                            )}


                        </>)}
                </div>


                <div style={{ width: "15%", padding: "15px 0", position: "relative", top: "20px" }}>Level {empathyLevel} Friend</div>
                <div style={{ width: "15%", float: "left", padding: "15px 0" }}>Empathy</div>
                <Progress style={{ width: "80%", float: "left", margin: "1em" }} color='violet' percent={empathy} inverted />
                <div style={{ clear: "both" }} />



            </VanishDiv>
        )}
    </FrameVanishDiv>;




    function Chat() {
        setLocked(true);
        setLastAction("Chat");
        let value = help.randBetween(10, 20);
        NextMoment(0, moodValue, conversation + value, energy - 10, friendEnergy - 10);
    }

    function Cheer() {
        setLocked(true);
        setLastAction("Cheer");
        let value = help.randBetween(10, 20);
        if (feeling == "receptive") value = value * 2;
        if (feeling == "feeling seen") value = value * 3;
        if (feeling == "distant") value = value / 2;
        NextMoment(5, moodValue + value, conversation, energy - 10, friendEnergy - 10);
    }

    function Silence() {
        setLocked(true);
        setLastAction("Silence");
        NextMoment(-1, moodValue, conversation, energy + 10, friendEnergy + 10);
    }

    function DeepTalk() {
        setLocked(true);
        setLastAction("Deep Talk");
        let value = help.randBetween(20, 30);
        if (feeling == "receptive") value = value * 2;
        if (feeling == "feeling seen") value = value * 3;
        if (feeling == "distant") value = value / 2;
        NextMoment(5, moodValue + value, conversation, energy - 10, friendEnergy - 20);
    }

    function Soothe() {
        setLocked(true);
        setLastAction("Soothe");
        NextMoment(0, moodValue, conversation, energy - 10, friendEnergy + 10);
    }

    function FondGoodbye() {
        setLocked(true);
        setLastAction("Fond Goodbye");
        let newConversation = help.randBetween(10, 20);
        let newMood = help.randBetween(10, 20);
        if (feeling == "receptive") newMood = newMood * 3;
        else if (feeling == "feeling seen") newMood = newMood * 4;
        else if (feeling == "distant") newMood = newMood;
        else newMood = newMood * 2;
        NextMoment(0, moodValue + newMood, conversation + newConversation, 0, friendEnergy, "Fond Goodbye");
    }




    function getFeelingFromMood(moodVal) {
        let newFeeling = "sad";
        if (moodVal < 30) newFeeling = "sad";
        else if (moodVal < 60) newFeeling = "a little better";
        else if (moodVal < 85) newFeeling = "okay";
        else newFeeling = "happy";
        return newFeeling;
    }

    function NextMoment(iMoodBoost, iMoodValue, iConversation, iEnergy, iFriendEnergy, iLastAction = "") {
        let newFeeling = getFeelingFromMood(iMoodValue);

        let rand = help.randBelow(100);
        if (iMoodBoost != -1) {
            if (rand < 10 + iMoodBoost) newFeeling = "feeling seen";
            if (rand < 20 + iMoodBoost) newFeeling = "receptive";
            if (rand > 85 + iMoodBoost) newFeeling = "distant";
        }

        setFeeling(newFeeling);
        setFeelingColor(feelingsToColors[newFeeling]);
        setConversation(iConversation);
        setMoodValue(iMoodValue);
        setEnergy(iEnergy);
        setFriendEnergy(iFriendEnergy);

        setTimeout(() => { testEnd(iMoodValue, iConversation, iEnergy, iFriendEnergy, iLastAction); }, 100);

    }

    function testEnd(iMoodValue, iConversation, iEnergy, iFriendEnergy, iLastAction) {
        if (iConversation >= 100 || iEnergy <= 0 || iFriendEnergy <= 0) endGame(iMoodValue, iConversation, iEnergy, iFriendEnergy, iLastAction);
        else setLocked(false);
    }

    function endGame(iMoodValue, iConversation, iEnergy, iFriendEnergy, iLastAction) {

        let causeOfEnd = "";
        if(iLastAction == "Fond Goodbye") causeOfEnd = "You say goodbye.";
        else if (iConversation >= 100) causeOfEnd = "You finish talking.";
        else if (iEnergy <= 0) causeOfEnd = "You are too tired to keep talking.";
        else if (iFriendEnergy <= 0) causeOfEnd = "Your friend is too tired to keep talking.";

        setEndLine1(causeOfEnd);
        setEndLine2("");
        setEndingValue(1);

        setTimeout(() => {
            let friendResponse = "";
            if (iConversation >= 100) {
                friendResponse = "Your friend is glad you finished your conversation.";
                iMoodValue = iMoodValue + help.calcPercent(iMoodValue, 10)
                setMoodValue(iMoodValue);
            }
            else {
                friendResponse = "Your friend is disappointed you didn't get to finish your conversation.";
                iMoodValue = iMoodValue - help.calcPercent(iMoodValue, 50)
                setMoodValue(iMoodValue);
            }
            setEndLine2(friendResponse);
            setEndingValue(2);


            setTimeout(() => {
                let newFeeling = getFeelingFromMood(iMoodValue);
                setFeeling(newFeeling);
                setFeelingColor(feelingsToColors[newFeeling]);
                setEndingValue(3);

                setTimeout(() => {
                    let empathyIncrease = iMoodValue;
                    if (empathyIncrease < 10) empathyIncrease = 10;
                    setLevelUpText("");

                    let newEmpathy = empathy + empathyIncrease;
                    if (newEmpathy > 100) {
                        newEmpathy = 0;
                        let nextLevel = empathyLevel + 1;
                        let levelText = "Leveled Up Empathy! ";
                        if(nextLevel == 2) levelText += "Learned Skill: Pleasant Silence";
                        else if(nextLevel == 3) levelText += "Learned Skill: Deep Talk";
                        else if(nextLevel == 4) levelText += "Learned Skill: Soothe";
                        else if(nextLevel == 5) levelText += "Learned Skill: Fond Goodbye";
                        else levelText += "You've mastered all skills. You can keep playing if you like.";
                        setLevelUpText(levelText);
                        setEmpathyLevel(nextLevel);
                    }
                    setEmpathy(newEmpathy);
                    setEndingValue(4);

                }, 1000);


            }, 1000);

        }, 1000);


    }

    function NewFriend() {
        setEnergy(maxEnergy);
        setFriendEnergy(maxFriendEnergy);
        setConversation(0);
        setMoodValue(0);
        let newFeeling = getFeelingFromMood(0);
        setFeeling(newFeeling);
        setFeelingColor(feelingsToColors[newFeeling]);
        setEndingValue(0);
        setLocked(false);
        setLastAction("");

    }



    function startGame() {


        //setPlotCount(1);

    }


}

export default AreaGame;